import { useTranslation } from "react-i18next";
import Select from "common/components/Select/Select";
import { useMemo } from "react";

export type ProcessOptionsType = (options: string[]) => {
  value: string;
  label: string;
}[];

function ColorItem({ color, label }: { color?: string; label?: string }) {
  return (
    <div className="flex flex-row items-center gap-2">
      <div
        className="h-7 w-7 rounded-full"
        style={{ backgroundColor: color ?? "white" }}
      />
      <span>{label}</span>
    </div>
  );
}

function ColorSelect(props: any) {
  const { t } = useTranslation();

  const optionsType = props.optionsType || "dark";

  const darkOptions = useMemo(
    () => [
      { value: "#1e293b", label: <ColorItem color="#1e293b" label="Gris" /> },
      { value: "#991b1b", label: <ColorItem color="#991b1b" label="Rouge" /> },
      {
        value: "#92400e",
        label: <ColorItem color="#92400e" label="Orange" />,
      },
      {
        value: "#3f6212",
        label: <ColorItem color="#3f6212" label="Vert" />,
      },
      { value: "#164e63", label: <ColorItem color="#164e63" label="Cyan" /> },
      {
        value: "#1e3a8a",
        label: <ColorItem color="#1e3a8a" label="Bleu" />,
      },
      {
        value: "#581c87",
        label: <ColorItem color="#581c87" label="Violet" />,
      },
      {
        value: "#831843",
        label: <ColorItem color="#831843" label="Rose" />,
      },
    ],
    []
  );

  const lightOptions = useMemo(
    () => [
      { value: "yellow", label: <ColorItem color="yellow" label="Jaune" /> },
      { value: "aqua", label: <ColorItem color="aqua" label="Eau" /> },
    ],
    []
  );

  const noneOption = useMemo(() => ({ value: null, label: "Par défaut" }), []);

  return (
    <Select
      options={
        optionsType === "dark"
          ? [noneOption, ...darkOptions]
          : optionsType === "light"
          ? [noneOption, ...lightOptions]
          : [noneOption, ...darkOptions, ...lightOptions]
      }
      icon="StarIcon"
      {...props}
    />
  );
}

export default ColorSelect;
